import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {useDiagramLayoutContext} from './DiagramLayoutContext';

export interface WarehouseDiagramTableFooterProps {
  tableName: string;
  expanded: boolean;
}

export default function WarehouseDiagramTableFooter(props: WarehouseDiagramTableFooterProps): JSX.Element {
  const {expandTableColumns, collapseTableColumns} = useDiagramLayoutContext();

  function handleToggleExpanded(): void {
    if (props.expanded) {
      collapseTableColumns(props.tableName);
    } else {
      expandTableColumns(props.tableName);
    }
  }
  return (
    <div className={css(styles.footer)}>
      <Button
        text={props.expanded ? 'See fewer columns' : 'See more columns'}
        onClick={handleToggleExpanded}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MINI}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  footer: {
    marginTop: 3,
    textAlign: 'center',
  },
});
